const InputValidator = (value) => {
    const isValidLength = value.length >= 2 && value.length <= 50;
    const isValidFormat = /^[a-zA-Z\s,-]+$/.test(value);
    return isValidLength && isValidFormat;
};

export default InputValidator;